<app-content-header [contentHeader]="contentHeader"></app-content-header>

<div class="card">
    <div class="row p-25">
        <div class="col-xl-3 col-md-6 col-sm-12">
            <ng-select [items]="companies" bindValue="id" bindLabel="companyName" placeholder="Firma Seç"
                [(ngModel)]="selectedCompanyId" (change)="onCompanySelect($event)"></ng-select>
        </div>
        <div class="col-xl-3 col-md-6 col-sm-12">
            <ng-select [items]="certificateCompanies" bindValue="id" bindLabel="companyName"
                placeholder="Sertfika Bas. Firma Seç" [(ngModel)]="selectedCertificateCompanyId"
                (change)="onCertificateCompanySelect($event)"></ng-select>
        </div>
        <div class="col-xl-2 col-md-3 col-sm-12">
            <ng-select [items]="kinds" bindValue="id" bindLabel="typeName" placeholder="Cihaz Türü Seç" [(ngModel)]="selectedKind"
                (change)="onKindSelect($event)"></ng-select>
        </div>
        <div class="col-xl-3 col-md-3 col-sm-12">
            <div class="input-group">
                <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
                    placeholder="yyyy-mm-dd - yyyy-mm-dd" [value]="displayDateRange()" (click)="datepicker.toggle()"
                    (dateSelect)="onDateSelection($event)" [autoClose]="'outside'" [dayTemplate]="rangeSelectionDP"
                    outsideDays="hidden" [startDate]="fromDate!" />
                <ng-template #rangeSelectionDP let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                        [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                        (mouseleave)="hoveredDate = null">
                        {{ date.day }}
                    </span>
                </ng-template>
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary feather icon-calendar" (click)="datepicker.toggle()"
                        type="button"></button>
                </div>
            </div>
        </div>
            <button type="button" class="btn btn-icon btn-flat-danger" rippleEffect (click)="resetFilter()">
                <span [data-feather]="'trash'"></span></button>
        <label class="align-items-center">
            <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="50">50</option>
            </select>
        </label>
    </div>
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true">

        <ngx-datatable-column name="Cihaz Adı">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.deviceName}}
                <br>
                <span class="text-muted font-small-2"><strong>SeriNo :</strong>{{row.seriNo}}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Cihaz Türü" prop="typeName"></ngx-datatable-column>

        <ngx-datatable-column name="Firma">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.deliveryCompanyName}}
                <br>
                <span class="text-muted font-small-2"><strong>Sert. Bas. :</strong>{{row.certificateCompanyName}}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Teslim Tarihi">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.deliveryDate | date:'dd.MM.yyyy'}}
            </ng-template>
        </ngx-datatable-column>

        <!-- <ngx-datatable-column name="Durum">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="badge" [ngClass]="{
                    'badge-info': row.name === 'Bekliyor',
                    'badge-success': row.name === 'Tamamlandı',
                    'badge-danger': row.name === 'İptal Edildi',
                    'badge-warning': row.name !== 'Bekliyor' && row.name !== 'Tamamlandı' && row.name !== 'İptal Edildi'
                }">
                    {{ row.name }}
                </span>

            </ng-template>
        </ngx-datatable-column> -->

        <ngx-datatable-column name="#" [sortable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="d-flex align-items-center">
                    <button (click)="showCreateCalibrationDialog(row.id)" class="btn btn-sm btn-flat-primary">
                        <span [data-feather]="'file-minus'"></span>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious>
                            <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>